import axiosInstance from '../api/axios';

export const getAllCapstoneProjects = async () => {
    try {
        const response = await axiosInstance.get(`/capstoneProject`);
        return response.data;
    } catch (error) {
        console.error('Error fetching capstone projects:', error);
        throw error;
    }
};

export const presignCapstoneUpload = async (studentId, filename) => {
    try {
        const response = await axiosInstance.post(`/capstoneProject/presign-upload`, { studentId, filename });
        return response.data;
    } catch (error) {
        console.error('Error presigning capstone project upload:', error);
        throw error;
    }
};

export const saveCapstoneMetadata = async (studentId, objectKey, originalFilename) => {
    try {
        const response = await axiosInstance.post(`/capstoneProject/metadata`, { studentId, objectKey, originalFilename });
        return response.data;
    } catch (error) {
        console.error('Error saving capstone project metadata:', error);
        throw error;
    }
};

export const toggleCapstoneShare = async (studentId) => {
    try {
        const response = await axiosInstance.put(`/capstoneProject/share?studentId=${studentId}`);
        return response.data;
    } catch (error) {
        console.error('Error toggling capstone project share status:', error);
        throw error;
    }
};

export const getCapstoneDownloadUrl = async (studentId) => {
    try {
        const response = await axiosInstance.get(`/capstoneProject/download?studentId=${studentId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching capstone project download URL:', error);
        throw error;
    }
};

export const getMyCapstoneProject = async () => {
    try {
        const response = await axiosInstance.get(`/capstoneProject/mine`);
        return response.data;
    } catch (error) {
        console.error('Error fetching my capstone project:', error);
        throw error;
    }
};
